/**
* A product can be a real article from different type of vending machines or charging money.
*             This value may influence the way a product is presented, e.g. in the product editor.
*/
export enum ProductType { 
	/**
	* The default case: A real product, which is dispensed from a vending machine,
	*             like a cup of coffee or a sandwich. When possible, prefer the more specialiced
	*             types below.
	*/
	Article = "Article", 
	/** Loading money on a closed-loop card. */
	Charging = "Charging", 
	/**
	* Product dispensed by the <see cref="F:Iovent.Model.Devices.Config.Machine.MachineType.Eversys" /> coffee machine, like a cappuccino,
	*             espresso, milk foam or hot water.
	*/
	Eversys = "Eversys", 
	/** Product dispensed by the <see cref="F:Iovent.Model.Devices.Config.Machine.MachineType.SandenVendoVM" /> vending machine. */
	SandenVendoVM = "SandenVendoVM"
}
